"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneNumberUtil = void 0;
class PhoneNumberUtil {
  static maskPhoneNumber(phoneNumber) {
    if (!phoneNumber) return "";
    // Strip all non-numeric characters
    let phone = phoneNumber.replace(/\D/g, "");
    if (phone.length > 6) {
      phone = phone.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, "($1) $2-$3");
    } else if (phone.length > 3) {
      phone = phone.replace(/^(\d{0,3})(\d{0,3})/, "($1) $2");
    } else if (phone.length > 0) {
      phone = phone.replace(/^(\d{0,3})/, "($1");
    }
    // Remove extra white-space that is inserted by the above replace until there are enough characters
    phone = phone.trim();
    return phone;
  }
  static validatePhoneNumber(phoneNumber) {
    const strippedPhoneNumber = phoneNumber?.replace(/\D/g, "");
    if (strippedPhoneNumber.startsWith("0") || strippedPhoneNumber.startsWith("1")) {
      return {
        valid: false,
        error: "Phone number cannot have either 0 or 1 in the first digit"
      };
    }
    if (strippedPhoneNumber.length !== 10) {
      return {
        valid: false,
        error: "Please enter a valid ten-digit phone number"
      };
    }
    return {
      valid: true,
      error: ""
    };
  }
  static moveCursorForPhoneNumber(input, cursorPosition, previousCharCount, phone, phoneNumber, event) {
    if (!(input instanceof HTMLInputElement)) {
      return;
    }
    const isDeleteEvent = event.inputType === "deleteContentBackward" || event.inputType === "deleteContentForward";
    // Get current number of non-numeric characters
    // get current number of non numeric characters
    const currentCharCount = (phone.match(/\D/g) || []).length;
    if (typeof phone === "string" && typeof phoneNumber === "string" && previousCharCount < currentCharCount && phoneNumber.substring(cursorPosition, phoneNumber.length) === "") {
      // If a new non numeric characters was inserted by the above regex and there are not any characters to the right of the cursor.
      // For example (x is the user's cursor, 9 is the entered character) (724x -> (724) 9x
      cursorPosition += currentCharCount - previousCharCount;
    } else if (!isDeleteEvent && phoneNumber[cursorPosition] === ")") {
      // If they are not deleting a character and the next character is the closing parenthesis, move their
      // cursor to before the next number.
      // For example (x is the user's cursor, 9 is the entered character) (724x) 773-408 -> (724) 9x77-3408
      cursorPosition += 2;
    } else if (!isDeleteEvent && (phoneNumber[cursorPosition] === "(" || phoneNumber[cursorPosition] === ")" || phoneNumber[cursorPosition] === "-")) {
      // If they are not deleting a character and the next character is one of our inserted characters, move their
      // cursor to before the next number.
      // For example (x is the user's cursor, 9 is the entered character) (724) 977x-340 11 -> (724) 977-x9340
      cursorPosition++;
    }
    input.setSelectionRange(cursorPosition, cursorPosition);
  }
}
exports.PhoneNumberUtil = PhoneNumberUtil;
